// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__JW_WK","alert":"SettungsInbox_alert__2BzF3"};